import { Injectable, Injector } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LocationStrategy, PathLocationStrategy } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Router, Event, NavigationError } from '@angular/router';
import { ToastService } from 'ng-uikit-pro-standard';
// declare var window: any;
import * as StackTraceParser from 'error-stack-parser';


@Injectable()
export class ErrorsService {

  constructor(
    private injector: Injector,
    private router: Router,
    public toastr: ToastService,
    private translate: TranslateService,

  ) {
    // Subscribe to the NavigationError
    this.router
      .events
      .subscribe((event: Event) => {
        if (event instanceof NavigationError) {
          // Redirect to the ErrorComponent
          this.log(event.error)
            .then((errorWithContext) => {
              this.router.navigate(['/server-error'], { queryParams: errorWithContext })
            });
        }
      });
  }

  log(error) {

    return new Promise((resolve, reject) => {
      resolve(error)
  //    console.error(error)
    })
    /*     const appConstants = this.injector.get(AppConstants);
        return new Promise((resolve, reject) => {
          const errorToSend = this.addContextInfo(error);
          const http = this.injector.get(SharedService);      
          http.post(window.location.origin + "/truscheduling/error", errorToSend,{}).subscribe(res => {
            resolve(res)
          }, err => {
            reject(err)
          })
        }) */
  }

  toastrLog(error) {
    let errorLog = error;
    if (errorLog.status == 0 || errorLog.status == 502 || errorLog.status == 503) {
      if (errorLog && errorLog.url) {       
        if (errorLog.url.indexOf("trutesta-testplan-services") != -1){          
          this.router.navigate(['server-error'], { queryParams: { errorCode: errorLog.status } });
          this.toastr.error(this.translate.instant("administration_serviceUnavailableError_label"));
        }          
      }
    }
    else{
      const errorResponse = errorLog.error;
      let errorMessage = '';
      if (errorResponse && typeof errorResponse === 'string')
        errorMessage = errorLog.error

      else if (errorResponse && typeof errorResponse === 'object' && errorResponse.errorMessage && !errorResponse.violations)
        errorMessage = errorResponse.errorMessage
      else if (errorResponse && typeof errorResponse === 'object' && errorResponse.violations && errorResponse.violations.length
      ) {
        let violations: any = errorResponse.violations;
        violations.map((violation: any) => {
          this.toastr.error(violation.errorMessage, '');
        });
      }

      if (errorMessage && errorMessage.length)
        this.toastr.error(errorMessage, '', { timeOut: 30000 });
    }         
  }

  addContextInfo(error) {
    // You can include context details here (usually coming from other services: UserService...)
    const name = error.name || null;
    const appId = 'trutestPlans';
    const user = 'KeycloakService.auth.userInfo.preferred_username;'
    const time = new Date().getTime();
    const id = `${appId}-${user}-${time}`;
    const location = this.injector.get(LocationStrategy);
    const url = location instanceof PathLocationStrategy ? location.path() : '';
    const status = error.status || null;
    const message = error.message || error.toString();
    const stack = error instanceof HttpErrorResponse ? null : StackTraceParser.parse(error);

    const errorWithContext = { name, appId, user, time, id, url, status, message, stack };
    return errorWithContext;
  }
}
